module.exports = {"pagination":{"DescribeAccessPoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeFileSystems":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems"},"DescribeTags":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticfilesystem-2015-02-01.paginators.json
// module id = 547
// module chunks = 1